import CustomIcon from 'components/icon/CustomIcon'
import React from 'react'
import styled from 'styled-components'
import { icons } from 'utils/icons'
import { presets } from '../presets'
import Image from 'components/file/image/Image'

interface IVideoProps {
  source: string
  preset:
    | 'preview'
    | 'input'
    | 'files'
    | 'fullscreen'
    | 'post'
    | 'editPost'
    | 'postInput'
    | 'editPostResponsive'
  type: string
  thumbnail?: string
  isAudio?: boolean
}

const Video = ({ source, preset, thumbnail, isAudio}: IVideoProps) => {
  return (
    <div style={{ position: 'relative' }}>
      {(preset === 'preview' || preset === 'post') && (
        <OverLay>
          <CustomIcon iconPreset="large" source={icons.sendActiveRecordPlay} />
        </OverLay>
      )}

      {isAudio && (
        <StyledFullScreenAudio>
          <CustomIcon
            source={icons.audioPng}
            width="400px"
            height="150px"
          />
        </StyledFullScreenAudio>
      )}

      {preset !== 'fullscreen' && thumbnail && <Image source={thumbnail} preset={preset} />}

      {(preset === 'fullscreen' || !thumbnail) && (
        <StyledVideo {...presets[preset].video} controls={preset === 'fullscreen'} className={preset === 'fullscreen' ? 'fullscreen-video' : ''}>
          <source src={source}  />
          Your browser does not support the video tag.
        </StyledVideo>
      )}
    </div>
  )
}

export default React.memo(Video, (prevProps, nextProps) => {
  // Tüm props özelliklerini kontrol et, herhangi biri değiştiyse bileşeni yenile
  return (
    prevProps.preset === nextProps.preset &&
    prevProps.source === nextProps.source &&
    prevProps.type === nextProps.type &&
    prevProps.thumbnail === nextProps.thumbnail
  )
})

const StyledVideo = styled.video.attrs(
  (props: { maxWidth: string; maxHeight: string; borderRadius: string; objectFit: string }) =>
    props,
)`
  width: 100%;
  height: 100%;
  max-width: ${({ maxWidth }) => maxWidth};
  max-height: ${({ maxHeight }) => maxHeight};
  object-fit: ${({ objectFit }) => objectFit};
  border-radius: ${({ borderRadius }) => borderRadius};
  
  &.fullscreen-video {
    width: auto;
    height: auto;
  }
`

const OverLay = styled.div`
  position: absolute;
  background-color: rgba(0, 0, 0, 0.1);
  width: 100%;
  height: 100%;
  display: grid;
  place-items: center;
`

const StyledFullScreenAudio = styled.div`
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
`
